import { useMutation } from "react-query";
import { API } from "../api";

export const useUpdateStock = () => useMutation(API.updateStock)